import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import cssStyles from '../../../css/css-variables';
import { ENABLE_SIDENAV_MENU } from '../constants';

const StyledLi = styled.li`
  border: none;

  li & {
    font-size: 14px;
    border-top: none;
  }

  ${({ isMenu }) => isMenu &&
  `
    font-size: ${ENABLE_SIDENAV_MENU ? '14px' : '18px'};
  `
  }
  ${({ isActive }) => isActive &&
    `
      background-color: ${cssStyles.colors.Background};
    `
  }

  ${({ firstChild }) => firstChild && 'border-top: none;'}

  @media(max-width: 720px) {
    border: none;
    margin: 2px 0;
  }
`;

StyledLi.displayName = 'StyledLi';


const ListItem = props => {
  const { isActive, isMenu, onClick, children, firstChild, className } = props;
  const qaHook = (props['data-qa-hook']) ? { 'data-qa-hook': props['data-qa-hook'] } : null;

  const classNames = [
    className,
    isActive && 'active'
  ]
    .filter(name => name != null && name != false)
    .join(' ');

  return <StyledLi className={classNames} firstChild={firstChild} isActive={isActive} isMenu={isMenu} onClick={onClick} {...qaHook}>{children}</StyledLi>;
};

const { bool, string, node, func } = PropTypes;

ListItem.propTypes = {
  'data-qa-hook': string,
  className: string,
  firstChild: bool,
  isMenu: bool,
  isActive: bool,
  children: node,
  onClick: func
};

export default ListItem;

